<ng5-slider class="col-9" [(value)]="value" [options]="options" (userChange)="onChange($event)"></ng5-slider>
